import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { IonModal, IonContent, IonFooter, IonHeader } from '@ionic/react'
import { refundMobx } from '@mobx/order'
import './index.scss'

interface IProps {
  reject?: any;
  resolve?: (data: string) => void;
  data: string;
}

const ReasonsModal: FC<IProps> = (props) => {
  const { reject, resolve, data } = props
  const [reason, setReason] = useState(data)
  const { refundConfig: { orderReasons = [] } } = refundMobx
  const handleChange = (value: string) => {
    setReason(value)
  }

  const handleConfirm = () => {
    resolve?.(reason)
  }

  return (
    <IonModal
      isOpen
      cssClass='reason-modal'
      swipeToClose
      onDidDismiss={() => reject?.()}
    >
      <IonHeader>
        <div className='reason-title'>
          <span>{i18n.t('refund.refundReasonSelect')}</span>
          <i className='iconfont icon-close' data-cypid='reasonModalClose' onClick={() => reject?.()}></i>
        </div>
      </IonHeader>
      <IonContent className='reason-content' scrollEvents>
        <div className='reason-desc'>{i18n.t('refund.refundReasonSelectDesc')}</div>
        <div className='reason-modal-content'>
          {
            orderReasons.map((item, index) => {
              const selected = item.name === reason
              return (
                <div className='reason-item-wrapper' key={item.name} onClick={() => handleChange(item.name)}>
                  <span className='content'>{item.name}</span>
                  {selected ? (
                    <div className='select-mark has-select'>
                      <i className='iconfont icon-checked'></i>
                    </div>
                  ) : (
                    <div className='select-mark no-select'></div>
                  )}
                </div>
              )
            })
          }
        </div>
      </IonContent>
      <IonFooter className='reason-footer'>
        <div className='reason-button' data-cypid='reasonModalConfirm' onClick={handleConfirm}>{i18n.t('common.confirm')}</div>
      </IonFooter>
    </IonModal>
  )
}

export default observer(ReasonsModal)
